<template>
  <v-row>
    <v-col cols="12" md="12">
      <BaseBlock>
        <v-tabs v-model="tab">
          <v-tab key="Editeur de messages">Editeur de messages</v-tab>
          <v-tab key="MAINTENANCE">Maintenance</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="Editeur de messages">
            <v-autocomplete
              v-model="text"
              :items="texts"
              :loading="isLoading"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              item-text="type"
              label="edition des messages"
              prepend-icon="mdi-database-search"
              return-object
            ></v-autocomplete>
            <p>Légende : Info, Accueil, Signature, Mail</p>
            <br />
            <tiptap v-model="text.message" v-if="text && !isLoading" />
            <br />
            <v-btn color="success" @click="enregistrementHTML" :disabled="!text"
              >Enregistrer</v-btn
            >
            <v-card>
              <v-card-title v-if="text && /^MAIL/i.test(text.type)">
                <span class="headline">Les variables :</span>
              </v-card-title>
              <v-card-text>
                <div v-for="n in variables" :key="n">
                  {{ n }}
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="MAINTENANCE">
            <v-form
              lazy-validation
              ref="formMaintenance"
              v-model="formMaintenance"
            >
              <v-menu
                v-model="showCalendarMaintenance"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDate"
                    label="Date de fin de la maintenance"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  v-model="maintenance.date"
                  type="date"
                  :min="new Date(Date.now()).toISOString().substring(0, 10)"
                  @input="showCalendarMaintenance = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                ref="heure"
                v-model="showCalendarClockMaintenance"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="maintenance.time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="maintenance.time"
                    label="Heure de fin de la maintenance"
                    prepend-icon="schedule"
                    readonly
                    v-on="on"
                    v-bind="attrs"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="showCalendarClockMaintenance"
                  v-model="maintenance.time"
                  format="24hr"
                  full-width
                  :allowed-minutes="(v) => v % 5 === 0"
                  @click:minute="$refs.heure.save(maintenance.time)"
                ></v-time-picker>
              </v-menu>
              <br />
              <v-text-field
                name="Message de maintenance"
                label="Message de maintenance"
                v-model="maintenance.message"
                required
                :rules="[(value) => !!value || 'Champ requis.']"
              ></v-text-field>
              <br />
              <v-btn
                color="success"
                @click="enregistrementParametresMaintenance"
                :disabled="!formMaintenance"
                >Enregistrer</v-btn
              >
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </BaseBlock>
    </v-col></v-row
  >
</template>
textAccueil
<script>
import BaseBlock from "@/components/base/BaseBlock";
import Tiptap from "@/components/base/Tiptap";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import ApiParametresRepository from "@/repositories/ApiParametresRepository";
import moment from "moment";

export default {
  components: { BaseBlock, Tiptap },
  data() {
    return {
      tab: null,
      textAccueil: "",
      textAccueilDRH: "",
      textInformation: "",
      texts: [],
      text: null,
      showCalendarMaintenance: false,
      showCalendarClockMaintenance: false,
      maintenance: {
        date: null,
        time: null,
        message: null,
      },
      formMaintenance: true,
      isLoading: false,
      search: null,
      variables: null,
    };
  },
  computed: {
    formatedDate: {
      get: function () {
        return moment(this.maintenance.date).format("DD/MM/YYYY");
      },
    },
  },
  async mounted() {
    let parametresMaintenance =
      await ApiParametresRepository.getByNomStartingWithMaintenance();
    this.maintenance.date = parametresMaintenance["MaintenanceDateFin"];
    this.maintenance.message = parametresMaintenance["MaintenanceMessage"];
    this.maintenance.time = this.maintenance.date.substring(11, 16);
    this.maintenance.date = this.maintenance.date.substring(0, 10);
  },
  watch: {
    search: async function (val) {
      this.isLoading = true;
      this.texts = await ApiRefMessageRepository.getBySearch(val);
      this.isLoading = false;
    },
    text: async function (val) {
      if (this.text) {
        const matches = this.text.message.match(/#\{[^{}]*\}|#\{[^{}]*$/g);
        this.variables = matches;
      }
    },
  },
  methods: {
    async enregistrementHTML() {
      if (this.text.type.startsWith("MAIL")) {
        const ouverture = this.text.message.split("#{").length - 1;
        const fermeture = this.text.message.split("}").length - 1;
        if (ouverture == fermeture) {
          console.log(this.text.message);
          await ApiRefMessageRepository.setMessage(this.text);
          this.$toast.success("Message enregistré avec succès");
        } else this.$toast.error("L'expression n'est pas valide");
      } else {
        await ApiRefMessageRepository.setMessage(this.text);
        this.$toast.success("Message enregistré avec succès");
      }
    },
    async enregistrementParametresMaintenance() {
      console.log(this.maintenance.time);
      if (this.$refs.formMaintenance.validate()) {
        let message = {
          id: 2,
          nom: "MaintenanceMessage",
          valeur: this.maintenance.message,
        };
        let date = {
          id: 1,
          nom: "MaintenanceDateFin",
          valeur:
            this.maintenance.date + "T" + this.maintenance.time + ":00.000",
        };
        await ApiParametresRepository.update(message);
        await ApiParametresRepository.update(date);
      }
    },
  },
};
</script>
